import { render, staticRenderFns } from "./vue-draggable-resizable.vue?vue&type=template&id=635de075&"
import script from "./vue-draggable-resizable.vue?vue&type=script&lang=js&"
export * from "./vue-draggable-resizable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports